import React from 'react';
import './App.css';
import Dashboard from './components/Dashboard';
import RuleProcessor from './components/RuleProcessor';
import DenialWorksheet from './components/RuleProcessor/denialwork';
import NoResponseWorksheet from 'components/RuleProcessor/noResponseWork';
import RunRules from './components/RuleProcessor/runRules';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import InspectionNotRan from './components/Inspection-NotRan';
import InspectionNoViolation from './components/Inspection-NoViolation';
import PatientDetails from './components/Inspection-NoViolation/patient-details';
import CreateRule from './components/CreateRule/rule-builder';
import Insurances from './components/Insurances';
import Settings from './components/Settings/group';
import Login from './Auth/Login/login';
import PracticeSettings from './components/Settings/PracticeSettings/practice-settings';
import ManageRules from './components/ManageRule';
import RuleDashboard from './components/ManageRule/rule-dashboard';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';
import PropTypes from 'prop-types';
import Reports from './components/AutoRunRule/Reports';
import Logger from './components/Logger';
import LoggerDetails from './components/Logger/LoggerDetails';
import ForgotPassword from 'Auth/Login/ForgotPassword';
import InviteUser from 'Auth/Login/inviteUser';

// Initial path to check whether user is logged in or not
const PrivateRoute = ({ component: Component, roles, ...rest }) => {
  let user = JSON.parse(sessionStorage.getItem('userDetail'));
  const token = sessionStorage.getItem('token');
  const userRole = user?.roleId?.toString(); // Ensure string comparison

  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page
    // <Route {...rest} render={props => (
    //   sessionStorage.getItem('token') ?
    //         <Component {...props} />
    //     : <Redirect to="/" />
    // )} />
    <Route {...rest} render={props => {
      if (!token) return <Redirect to="/" />;

      // Convert roleId to string for comparison with ['1', '2', ...]
      // const userRole = user?.roleId;

      if (roles && !roles.includes(userRole)) {
        // Redirect logic based on role
        const redirectPath = userRole == "9" ? '/rule-processor' : '/dashboard';

        // Prevent infinite redirect: only redirect if we aren't already there
        if (props.location.pathname === redirectPath) {
          return <Component {...props} />;
        }
        return <Redirect to={redirectPath} />;
      }
      return <Component {...props} />;
    }} />
  );
};


PrivateRoute.propTypes = {
  component: PropTypes.element.isRequired,
}

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  const user = JSON.parse(sessionStorage.getItem('userDetail'));
  const token = sessionStorage.getItem('token');
  const userRole = user?.roleId;
  // return (
  //   <Route {...rest} render={props => (
  //     sessionStorage.getItem('token') && restricted ?
  //       <Redirect to="/dashboard" />
  //       : <Component {...props} />
  //   )} />
  // );
  return (
    <Route {...rest} render={props => {
      if (token && restricted) {
        // Dynamic redirect upon landing on Login page while already logged in
        return <Redirect to={userRole == "9" ? "/rule-processor" : "/dashboard"} />;
      }
      return <Component {...props} />;
    }} />
  );
};
PublicRoute.propTypes = {
  component: PropTypes.element.isRequired,
  restricted: PropTypes.bool.isRequired
}

function App() {
  return (
    <>
      <div className="App">
        <Router>
          <Switch>
            <PublicRoute restricted={true} path="/" exact component={Login} />
            <Route path="/forgot-password" component={ForgotPassword} />
            <Route path="/register" component={InviteUser} />
            <PrivateRoute path="/dashboard" component={Dashboard} exact roles={['1', '2', '3', '4', '5', '6', '7', '8']} />
            <PrivateRoute path="/rule-processor" component={RuleProcessor} exact roles={['1', '2', '3', '4', '5', '7', '8', '9']} />
            <PrivateRoute path="/denial-management" component={DenialWorksheet} exact roles={['1', '2', '3', '6', '7', '9']} />
            <PrivateRoute path="/noresponse-management" component={NoResponseWorksheet} exact roles={['1', '2', '3', '5', '6', '8', '9']} />
            <PrivateRoute path="/runRules" component={RunRules} exact />
            <PrivateRoute path="/manageRule/:ruleType?" component={ManageRules} exact roles={['1', '2', '3', '4', '5', '6', '7', '8']} />
            <PrivateRoute path="/rule-dashboard" component={RuleDashboard} roles={['1', '2', '3', '4', '5', '6', '7', '8']} />
            <PrivateRoute path="/inspection-notran" component={InspectionNotRan} roles={['1', '2', '3', '4', '5', '7', '8']} />
            <PrivateRoute path="/inspection-noviolation" component={InspectionNoViolation} roles={['1', '2', '3', '4', '5', '7', '8']} />
            <PrivateRoute path="/patient-details" component={PatientDetails} roles={['1', '2', '3', '4', '5', '7', '8', '9']} />
            <PrivateRoute key='create-rule' exact path="/create-rule" component={CreateRule} roles={['1', '2', '3', '5']} />
            <PrivateRoute key='edit-rule' exact path="/edit-rule/:ruleId" component={CreateRule} roles={['1', '2', '3', '5']} />
            <PrivateRoute path="/insurances/:encounterId?/:payerId?/:encounterType?" component={Insurances} exact roles={['1', '2', '3', '4', '5', '6', '7', '8']} />
            <PrivateRoute path="/settings" component={Settings} roles={['1', '2', '3', '4', '5', '6', '7', '8']} />
            <PrivateRoute path="/practice-settings" component={PracticeSettings} roles={['1', '2', '3', '4', '5', '6', '7', '8']} />
            <PrivateRoute path="/logs" component={Logger} roles={['1', '2', '3', '4', '5', '6', '7', '8']} />
            <PrivateRoute path="/logFileContent/:loggerName" component={LoggerDetails} roles={['1', '2', '3', '4', '5', '6', '7', '8']} />
            <PrivateRoute path="/Reports" component={Reports} exact roles={['1', '2', '3', '4', '5', '6', '7', '8']} />
            <PrivateRoute path="/*" component={notfound_page} exact />
          </Switch>
          <NotificationContainer />
        </Router>
      </div>
    </>
  );
}

function notfound_page() {
  return <>
    <h1>Page not Found</h1>
  </>
}

export default App;
